export default __webpack_public_path__ + "static/media/tools-bottom.f4b724e2.png";